var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ml-4 mr-4" }, [
    _vm.type === "create"
      ? _c(
          "div",
          [
            _c("div", { staticClass: "row py-3 align-items-center" }, [
              _c("div", { staticClass: "col company-h1" }, [
                _c("button", {
                  staticClass: "btn btn-back",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.setCompanyStep("companies-settings")
                    }
                  }
                }),
                _vm._v("\n        Create Company\n      ")
              ]),
              _vm._v(" "),
              _vm.$_can("companies.prices.store")
                ? _c("div", { staticClass: "col text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary ld-ext-right",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { type: "button", disabled: _vm.buttonDisabled },
                        on: { click: _vm.saveProfile }
                      },
                      [
                        _vm._v("\n          Save\n          "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("companies-steps-menu", { attrs: { type: "create" } })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "edit"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "row py-3 align-items-center company-header" },
            [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("h2", { staticClass: "company-h1 mr-3" }, [
                    _c("button", {
                      staticClass: "btn btn-back",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$router.push("/companies")
                        }
                      }
                    }),
                    _vm._v(
                      "\n          " + _vm._s(_vm.company.name) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.company.status
                    ? [
                        _vm.company.status.name === "Active"
                          ? _c("span", { class: "btn-status btn-active" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.company.status.name === "Inactive"
                          ? _c("span", { class: "btn-status btn-closed" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.company.status.name === "Setup Incomplete"
                          ? _c(
                              "span",
                              { class: "btn-status btn-ncover info-company" },
                              [
                                _vm._v(
                                  _vm._s(_vm.company.status.name) +
                                    "\n            "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btn btn-link p-0 tippy-popup tippy-info",
                                    on: {
                                      mouseover: function($event) {
                                        _vm.showTooltipPrefix = true
                                      },
                                      mouseout: function($event) {
                                        _vm.showTooltipPrefix = false
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-info-circle"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.showTooltipPrefix
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "popover tippy-info-popover"
                                      },
                                      [
                                        _vm._v(
                                          "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes,\n              arrival windows, merchant account, rates and coverage.\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-8 d-flex align-items-center justify-content-end"
                },
                [
                  _vm.$_can("companies.review.request")
                    ? _c("companies-visibility-bar", {
                        attrs: { company: _vm.company },
                        on: {
                          saved: function($event) {
                            _vm.$emit("saved")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ld-ext-right ml-5",
                      class: _vm.loadingButton ? "running" : "",
                      attrs: { type: "button", disabled: _vm.buttonDisabled },
                      on: { click: _vm.saveProfile }
                    },
                    [
                      _vm._v("\n          Save\n          "),
                      _c("div", { staticClass: "ld ld-ball ld-flip" })
                    ]
                  )
                ],
                1
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "label",
          {
            staticClass: "switch",
            on: {
              click: function($event) {
                _vm.toggleModBooking()
              }
            }
          },
          [
            _c("input", {
              attrs: { type: "checkbox" },
              domProps: { checked: _vm.company.use_mod_booking }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "check-slider round" })
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("Use Mod24 booking flow only")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _vm.company.use_mod_booking
          ? _c("small", [
              _vm._v(
                "\n        Booking URL: https://mod24.com/company-info/" +
                  _vm._s(_vm.company.slug) +
                  "\n      "
              )
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row p-3" }, [
      _vm.$_can("companies.images.store")
        ? _c(
            "div",
            { staticClass: "col-2 mr-0 pr-0 col-square-upload" },
            [
              _c("FilesUpload", {
                ref: "refLogoUpload",
                attrs: {
                  label: "<u>Browse</u> or drag<br> logo photo to upload",
                  src: _vm.company.logo,
                  "type-id": 3,
                  model: "companies",
                  "model-id": _vm.company.id,
                  recommended: "Recommended size is 200x200"
                },
                on: { update: _vm.loadCompany }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$_can("companies.update")
        ? _c("div", { staticClass: "col col-textarea-upload" }, [
            _c("div", { staticClass: "select-wrap" }, [
              _c("label", [_vm._v("Company description")]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.company.description,
                    expression: "company.description"
                  }
                ],
                staticClass: "form-control select-wrap-textarea cd-textarea",
                attrs: {
                  placeholder: "Enter company description",
                  cols: "20",
                  rows: "7"
                },
                domProps: { value: _vm.company.description },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.company, "description", $event.target.value)
                  }
                }
              })
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm.$_can("companies.images.store")
      ? _c(
          "div",
          { staticClass: "row mb-5" },
          [
            _c(
              "div",
              { staticClass: "col-12 col-sm-12 col-md-2" },
              [
                _c("FilesUploadGallery", {
                  ref: "refGalleryUpload",
                  attrs: {
                    label: "<u>Browse</u> or drag<br> photo to upload",
                    "type-id": 5,
                    "style-class": "square-upload",
                    model: "companies",
                    "model-id": _vm.company.id
                  },
                  on: { update: _vm.loadCompany }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.sortedImages
              ? _vm._l(_vm.sortedImages, function(image) {
                  return _c(
                    "div",
                    { key: image.id, staticClass: "col-12 col-sm-12 col-md-2" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "square-upload d-inline-block",
                          staticStyle: {
                            "background-size": "cover",
                            "background-position": "center",
                            position: "relative",
                            "border-radius": "2px",
                            outline: "none"
                          },
                          style: { backgroundImage: "url(" + image.url + ")" },
                          attrs: { id: image.id }
                        },
                        [
                          _c("div", { staticClass: "gallery-img-overlay" }, [
                            _c(
                              "div",
                              {
                                staticClass: "img-delete",
                                on: {
                                  click: function($event) {
                                    _vm.deleteImage(image)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../assets/img/gallery-close.svg")
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "image-position-change" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { width: "100%" },
                                    on: {
                                      click: function($event) {
                                        _vm.moveImageLeft(image.order)
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "gallery-left",
                                      attrs: {
                                        src: require("../../../assets/img/gallery-arrow.svg")
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "button-line" }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: { width: "100%" },
                                    on: {
                                      click: function($event) {
                                        _vm.moveImageRight(image.order)
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "gallery-right",
                                      attrs: {
                                        src: require("../../../assets/img/gallery-arrow.svg")
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                })
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "l-header-2" }, [
          _vm._v("\n        Website details\n      ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("p", { staticClass: "description-text" }, [
          _vm._v(
            "Information you add here will be visible on Mod24 website for your company."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "website-details-info-text" }, [
          _vm._v(
            "\n        Set up your company profile that will be to potential customers on Mod24 website. You can chose to remove your visibility by clicking Cancel visibility button. if you need further assistance, please contact us on "
          ),
          _c("b", [_vm._v("hello@mod24.com")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "l-header-2" }, [_vm._v("GALLERY")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c62f54c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c62f54c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/mod24settings/CompaniesProfile.vue
// module id = null
// module chunks = 